import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=385c5e89&scoped=true"
import script from "./attachment.vue?vue&type=script&lang=ts"
export * from "./attachment.vue?vue&type=script&lang=ts"
import style0 from "./attachment.vue?vue&type=style&index=0&id=385c5e89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c5e89",
  null
  
)

export default component.exports